import { css } from 'styled-components';

const mediaQueries = {
  mobile: (...args) => css`
    @media (max-width: ${props => props.theme.responsiveBreakpoint}px) {
      ${css(...args)}
    }
  `,
  desktop: (...args) => css`
    @media (min-width: ${props => props.theme.responsiveBreakpoint + 1}px) {
      ${css(...args)}
    }
  `,
};

export default mediaQueries;
